<template>

  <div id="ticketTagManage">
    <div class="dialog-content">

      <div v-if="editing" class="context">To edit a ticket tag, edit the fields below.</div>
      <div v-else class="context">To add a ticket tag, enter a name and description.</div>

      <!-- TITLE -->
      <v-text-field :validate-on-blur="$refs.inputTitle && $refs.inputTitle.valid" :rules="rules.title" ref="inputTitle" label="Title" v-model="ticketTag.title" prepend-icon="mdi-format-title"></v-text-field>

      <!-- DESCRIPTION -->
      <v-text-field :validate-on-blur="$refs.inputDescription && $refs.inputDescription.valid" :rules="rules.description" ref="inputDescription" multi-line no-resize :rows="2" label="Description" v-model="ticketTag.description" prepend-icon="mdi-note-text"></v-text-field>

    </div>
    <div class="dialog-footer">
      <v-btn class="button" flat color="info" @click="routeRemoveQueries(['dialog', 'dialogAction'])">Cancel</v-btn>
      <v-btn class="button" :loading="lockout.on" flat color="primary" @click="editing ? save() : create()">{{ editing ? 'Save' : 'Create' }}</v-btn>
    </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {
        editing: null,
        ticketTag: {
          name: '',
          description: ''
        },

        rules: {
          title: [
            function (e) {
              return !window.regex.title.test(e) ? 'Please enter a title.' : true;
            }
          ],
          description: [
            function (e) {
              return !window.regex.description.test(e) ? 'Please enter a description.' : true;
            }
          ]
        }
      }
    },

    methods: {

      create () {
        this.lockout.on = true;
        var valid = this.validate();

        if (!valid) {
          Toast.show('Please correct the highlighted errors.', 'error');
          this.lockout.on = false;
          return;
        } 

        this.$store.dispatch('createTicketTag', {
          company: this.$store.getters.company._id,
          ticketTag: this.ticketTag
        })
        .then(data => {
          this.app.pages.ticketTags.list.addItem(data._id, {unshift: true});

          this.routeAddQuery('details', data._id);
          this.routeRemoveQuery('dialog');

          // Reinit Filters to reflect changes
          window.AppData.initFilters();

          Toast.show('Ticket Tag created.', 'success');
          this.lockout.on = false;
        })
        .catch(e => {
          console.log(e);
          Toast.showError(e);
          this.lockout.on = false;
        })
      },

      save () {  
        var valid = this.validate();

        if (!valid) {
          Toast.show('Please correct the highlighted errors.', 'error');
          this.lockout.on = false;
          return;
        }

        this.$store.dispatch('updateTicketTag', {
          ticketTag: this.ticketTag
        })
        .then(data => {
          this.routeRemoveQuery('dialog');
    
          // Reinit Filters to reflect changes
          window.AppData.initFilters();

          Toast.show('Ticket Tag updated.', 'success');
          this.lockout.on = false;
        })
        .catch(e => {
          console.log(e);
          Toast.showError(e);
          this.lockout.on = false;
        });
      },

      validate () {
        this.$refs.inputTitle.validate(true);
        this.$refs.inputDescription.validate(true);
        return (this.$refs.inputTitle.valid && this.$refs.inputDescription.valid);        
      }

    },

    props: {
      dialogComponent: {

      },
      lockout: {
        
      }
    },

    created () {
      this.editing = this.$route.query.dialogAction && this.$route.query.dialogAction === 'edit';
 
      if (this.editing) {
        var selected = this.$store.getters.ticketTag(this.app.pages.ticketTags.selected);
        this.ticketTag = {
          _id: selected._id,
          title: selected.title,
          description: selected.description
        }
      }

      this.title = this.editing ? 'Edit Ticket Tag' : 'Create Ticket Tag'; 
      this.$emit('title', this.title);
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #ticketTagManage {
    position: relative;

    .dialog-content {
      padding: 16px;
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/TicketTagManage.vue